// src/app/profile/page.tsx
"use client"; 
import { createFileRoute } from '@tanstack/react-router'
import MainProfile from "@/components/user-profile/MainProfile";

function Profile() {
  
  return (
   <MainProfile/>
  );
}

export const Route = createFileRoute('/(user)/profile/')({
  component: Profile,
})
